import { Observable } from 'rxjs';
import Slider from '../../classes/slider';
import Main from '../../types/enums/main';
import promoRequest from './promoRequest';
const WAITING_TIME = 100;

function promoObservable(id: string) {
  return new Observable((subscriber) => {
    subscriber.next({
      type: Main.SLIDERS,
      data: [
        new Slider({ image: '', type: 'none' }, 0),
        new Slider({ image: '', type: 'none' }, 1),
        new Slider({ image: '', type: 'none' }, 2),
      ],
    });
    promoRequest(id).then((data) => {
      setTimeout(() => {
        subscriber.next({ type: Main.SLIDERS, data });
        subscriber.complete();
      }, WAITING_TIME);
    });
  });
}

export default promoObservable;
